<template>
  <v-main>
    <v-container fluid>
      <v-toolbar class="elevation-0" v-if="isBackoffice">
        <v-spacer></v-spacer>
        <v-btn text color="primary" :to="{ name: 'huggyAnalytics' }">
          <v-icon left>mdi-chart-bar</v-icon> Analytics Huggy
        </v-btn>
      </v-toolbar>
      <div style="width: 100%; height: calc(100vh - 90px)">
        <iframe
          src="https://calendar.google.com/calendar/embed?height=600&wkst=1&ctz=America%2FRecife&showPrint=0&showTz=0&showCalendars=0&showDate=0&title=Reuni%C3%A3o%20com%20as%20turmas&mode=WEEK&hl=pt_BR&src=Y18zZGJhNzNiMGY4ZTI1MWY5MzAxMzQ5MzMyNTFmYjk5NWJiMDZiNzE4MmZjOWZiMDIyMWZmNDgzYWQzM2I3NjQ3QGdyb3VwLmNhbGVuZGFyLmdvb2dsZS5jb20&color=%23F6BF26"
          style="border-width:0"
          width="100%"
          height="100%"
          frameborder="0"
          scrolling="no"></iframe>
      </div>
    </v-container>
  </v-main>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Calendar',
  computed: {
    ...mapGetters(['isBackoffice'])
  }
}
</script>
